//dependencias
import React, { Component } from 'react';

//componentes
import MateriasPAction from './permisoAO'

class Index extends Component {

    render(){
        return(
            <div>
                <MateriasPAction />
            </div>
        );
    }

}
export default Index;